import React, { useEffect, useState, memo } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import stl from './TipPaymentConfirmation.module.css';
import pageLogo from '../../assets/pageLogo.png';
import PersonCard from "../../molecules/PersonCard";
import PaymentFailure from "../../molecules/PaymentFailure";
import {logEvent} from "../../amplitude";
import getGuestId from "../../storage/getGuestId";

const TipPaymentConfirmation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const guestId = getGuestId();
    const storedBody = localStorage.getItem('body');
    const searchParams = new URLSearchParams(location?.search);
    const redirectStatus = searchParams.get('redirect_status');
    const paymentResultString = localStorage.getItem("paymentResult");
    const paymentResult = JSON.parse(paymentResultString)

    const [productInfo] = useState(() => {
        try {
            return JSON.parse(storedBody) || null;
        } catch (error) {
            console.error("Ошибка при разборе storedBody:", error);
            return null;
        }
    });

    const handleRetryPay = () => {
        navigate('/payment', {
            state: {
                product: productInfo,
            }
        });
    };

    useEffect(() => {
        if (redirectStatus === 'succeeded' && productInfo) {
            logEvent("Payment", {
                '$quantity': 1,
                '$price': productInfo?.amount,
                'Guest ID': guestId,
                'Fee': productInfo?.fee,
                'Tx ID': paymentResult?.id,
                '$revenue_type': paymentResult?.payment_method,
            });
        }
        return () => {
            localStorage.clear();
        };
    }, [redirectStatus, productInfo]);

    useEffect(() => {
        if (redirectStatus === 'succeeded' && productInfo) {
            logEvent("Page view", {
                Title: 'Payment success',
                Path: location.pathname,
                URL: window.location.href,
                'Guest ID': guestId,
            });
        }
    }, [redirectStatus]);
    return (
        <div className={stl.container}>
            <div className={stl.containerInner}>
                <div className={stl.pageLogoBox}>
                    <img src={pageLogo} alt='pageLogo' className={stl.pageLogo} />
                </div>
                {redirectStatus === 'succeeded' ? (
                    <div className={stl.personsList}>
                        <PersonCard imgClassName={stl.personImg} person={productInfo} />
                        <div className={stl.confirmMsgBox}>
                            <h2 className={stl.confirmMsg}>
                                Got your ${Number(productInfo?.amount)} tip.
                            </h2>
                        </div>
                    </div>
                ) : (
                    <PaymentFailure onRetry={handleRetryPay} />
                )}
            </div>
        </div>
    );
};

export default memo(TipPaymentConfirmation);
